
import Injection = EECore.Injection;
import ApplicationService from "../../services/application/applicationService";
import ApplicationServiceModel from "../../services/entities/application/application";
import Model from "../models/application/applicationModel";
import ItemModel from "../models/application/applicationItemModel";
import { WidgetResources } from "../../resources/widget";

@Injection.injectableClass("EEWidgets.Application")
export default class Application implements EECore.UI.IWebComponent {
  @Injection.injectableProperty("EEWidgets.Application", EECore.Registrations.TEMPLATE_FACTORY)
  private templateFactory: EECore.UI.TemplateFactory;

  @Injection.injectableProperty("EEWidgets.Application", "ApplicationService")
  private applicationService: ApplicationService;

  @Injection.injectableProperty("EEWidgets.Application", EECore.Registrations.WEBCOMPONENT_FACTORY)
  private webComponentFactory: EECore.UI.WebComponentFactory;

  @Injection.injectableProperty("EEWidgets.Application", EECore.Registrations.DOCUMENT)
  private document: Document;

  @Injection.injectableProperty("EEWidgets.Application", "WidgetResources")
  private resources: WidgetResources;

  @Injection.injectableProperty("EEWidgets.Application", EECore.Registrations.EVENT)
  private event: EECore.Event;

  @Injection.injectableProperty("EEWidgets.Application", EECore.Registrations.URL_HELPER)
  private urlHelper: EECore.Helpers.UrlHelper;

  constructor(templateFactory: EECore.UI.TemplateFactory, applicationService: ApplicationService, webComponentFactory: EECore.UI.WebComponentFactory, 
    document: Document, resources: WidgetResources, event: EECore.Event, urlHelper: EECore.Helpers.UrlHelper) {
    this.templateFactory = templateFactory;
    this.applicationService = applicationService;
    this.webComponentFactory = webComponentFactory;
    this.document = document;
    this.resources = resources;
    this.event = event;
    this.urlHelper = urlHelper;
  }

  load(container: Element, culture: string): EECore.Promise<Element, string> {

    return new EECore.Promise<Element, string>((resolve, reject) => {
      const title = container.getAttribute("ee-title");
      const template = this.renderTemplate(title);

      this.applicationService.getApplications().then((applications) => {
        const applicationContainer = template.querySelector(".application_content");
        const applicationsModel = this.applicationsToWebComponentModel(applications, culture);
        this.event.dispatch(container, "applicationsLoaded", { applications: applicationsModel });
        const renderedItems = this.renderItems(applicationsModel);

        applicationContainer.appendChild(renderedItems);
      }).catch(() => {
        reject("Could not get the applications.");
      });
      resolve(template);
    });
  }

  protected renderTemplate(title?: string): Element {
    const model = new Model();
    model.titleLabel = title ? title : this.resources.application.titleLabel;
    return this.templateFactory.getTemplate("Application", model);
  }

  protected renderItems(applications: ItemModel[]): Element {
    const documentFragment = this.document.createDocumentFragment() as any;

    for (let i = 0; i < applications.length; i++) {
      documentFragment.appendChild(this.templateFactory.getTemplate("ApplicationItem", applications[i]));
    }
    return documentFragment;
  }

  private applicationsToWebComponentModel(applications: ApplicationServiceModel[], culture: string): ItemModel[] {

    const applicationItemModels = new Array<ItemModel>();

    applications.forEach((application: ApplicationServiceModel) => {
      let applicationLabel;

      if (this.CurrentCultureIsEnglish(culture)) {
        applicationLabel = application.labelEn;
      } else {
        applicationLabel = application.labelFr;
      }

      const applicationMenuItemModel: ItemModel = {
        label: applicationLabel, // TODO - Missing Tests
        url: this.urlHelper.processUrl(application.url),
        linkTarget: application.openInNewWindow ? "_blank" : "_self" // TODO - Missing Tests
      };

      applicationItemModels.push(applicationMenuItemModel);
    });

    return applicationItemModels;
  }

  private CurrentCultureIsEnglish(culture: string): boolean {

    if (culture.substr(0, 2).toLowerCase() === "en") {
      return true;
    }
    return false;
  }

}